import { Link as RouterLink, useLocation } from 'react-router-dom';

import { Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { useTransl } from 'shared/lib/i18n';

const StyledFooter = styled('footer')(({ theme }) => ({
  backgroundColor: theme.palette.custom.footer,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '2rem',
  borderTop: '.1rem solid #dee2e6',
  [theme.breakpoints.down('sm')]: {
    padding: '1.5rem',
  },
}));

const FooterComponent = () => {
  const { pathname } = useLocation();
  const { t } = useTransl();
  const copyrightNote = `©${new Date().getFullYear()} ${t(
    'footer.copyright',
  )}`;
  return (
    <StyledFooter>
      <Typography variant="body1" align="center">
        {copyrightNote}&nbsp;|&nbsp;
        {pathname === '/support' ? (
          <span>{process.env.REACT_APP_VERSION}&nbsp;|&nbsp;</span>
        ) : null}
        <Link component={RouterLink} to="/support">
          {t('footer.support')}
        </Link>
        &nbsp;|&nbsp;
        <Link component={RouterLink} to="/terms-and-conditions">
          {t('footer.terms')}
        </Link>
        &nbsp;|&nbsp;
        <Link component={RouterLink} to="/privacy-policy">
          {t('footer.privacy')}
        </Link>
      </Typography>
    </StyledFooter>
  );
};

export default FooterComponent;
